import React from 'react'

import { LntDrawer } from '@app/components/base'

import { CommonMonitoringScheduleForm } from './CommonMonitoringScheduleForm'

import type { CommonMonitoringScheduleDrawerProps } from './types'

export const CommonMonitoringScheduleDrawer: React.FC<CommonMonitoringScheduleDrawerProps> = props => {
  const { data, onClose, onSubmit, ...restProps } = props

  return (
    <LntDrawer
      { ...restProps }
      onClose={ onClose }
      width={ 424 }
    >
      <CommonMonitoringScheduleForm
        data={ data }
        onSubmit={ onSubmit }
        onClose={ onClose }
      />
    </LntDrawer>
  )
}
